import { useMutation, useQueryClient } from 'react-query';

import { createClientWithObject } from 'api/clients/createClientWithObject';

const useCreateClientWithObject = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: createNewClientWithObject,
    isLoading,
  } = useMutation(createClientWithObject, {
    onSuccess: () => {
      queryClient.invalidateQueries('clients');
    },
  });

  return {
    isSuccess,
    createNewClientWithObject,
    isLoading,
  };
};

export default useCreateClientWithObject;
